import React, { FC } from "react";
// libs
import ReactPaginate from "react-paginate";
import NextImage from "next/image";
// hooks
import Router from "next/router";
// types
import { IPaginationProps } from "./pagination.types";
// theme
import Wrapper from "./pagination.styles";
import { amplitudeEvent, formatEventName } from "src/libs/amplitude";

const ITEMS_PER_PAGE = 10;

const previousLabel = <NextImage src="/icons/chevron-left.svg" width={6.2} height={10} />;
const nextLabel = <NextImage src="/icons/chevron-right.svg" width={6} height={10} />;

const Pagination: FC<IPaginationProps> = ({
  totalCount,
  shallow = true,
  setCurrentNumberPage,
  ...rest
}) => {
  const getCurrentPage = (): number =>
    Math.floor(parseInt((Router?.router?.query._start ?? "0") as string) / ITEMS_PER_PAGE);

  const onPageChange = async ({ selected }: { selected: number }): Promise<void> => {
    const currentPage = getCurrentPage();

    if (selected === currentPage + 1) {
      amplitudeEvent(formatEventName("search_results", "pagination", "next_page"));
    }

    if (selected === currentPage - 1) {
      amplitudeEvent(formatEventName("search_results", "pagination", "previous_page"));
    }

    if (selected > currentPage + 1 || selected < currentPage - 1) {
      amplitudeEvent(formatEventName("search_results", "pagination", "page_number"));
    }

    const query = Router?.router?.query;
    if (query?.area?.includes("service")) delete query?.services;
    const params = { ...query, _start: selected * ITEMS_PER_PAGE };
    if (setCurrentNumberPage) setCurrentNumberPage(selected + 1);
    await Router.replace(
      {
        pathname: Router?.router?.pathname,
        query: params,
      },
      undefined,
      { shallow },
    );
  };

  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const shouldRender = !!totalCount && totalCount > ITEMS_PER_PAGE;

  if (!shouldRender) return null;

  return (
    <Wrapper>
      <ReactPaginate
        key="react_paginate"
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        pageCount={pageCount}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        breakLabel="..."
        breakClassName="pagination_break"
        onPageChange={onPageChange}
        initialPage={getCurrentPage()}
        forcePage={getCurrentPage()}
        containerClassName="pagination_container"
        activeClassName="pagination_active"
        previousClassName="pagination_previous"
        nextClassName="pagination_next"
        // @ts-ignore
        subContainerClassName="pagination_subcontainer"
        {...rest}
      />
    </Wrapper>
  );
};

export default Pagination;
